<template>
  <div>
    <p class="title">冷藏车参数</p>
    <el-form
      :model="editProjectExtInfo"
      ref="editProjectExtInfo"
      :rules="editProjectExtInfoRules"
      class="demo-ruleForm"
    >
      <el-row>
        <el-col :span="18">
          <el-form-item
            label="车牌号"
            label-width="150px"
            prop="carnumber"
          >
           <el-input v-model="editProjectExtInfo.carnumber">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="18">
          <el-form-item label="长宽高" label-width="150px" prop="">
            <el-col :span="6"
              ><el-form-item label="" label-width="10px" prop="length">
                <el-input v-model="editProjectExtInfo.length">
                  <template #append>m</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="" label-width="10px" prop="width"
                ><el-input v-model="editProjectExtInfo.width">
                  <template #append>m</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6"
              ><el-form-item label="" label-width="10px" prop="height">
                <el-input v-model="editProjectExtInfo.height">
                  <template #append>m</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item label="体积" label-width="150px" prop="volume">
            <el-input v-model="editProjectExtInfo.volume" disabled="true">
              <template #append>m<sup>3</sup></template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="风机数" label-width="150px" prop="deviceqty">
                <el-input v-model="editProjectExtInfo.deviceqty">
                  <template #append>个</template>
                </el-input>
              </el-form-item>
        </el-col>
      </el-row>
     
      <el-row>
        <el-col :span="18">
          <el-form-item
            label="出入口数"
            label-width="150px"
            prop="entryexitqty"
          >
            <el-input v-model="editProjectExtInfo.entryexitqty"
              ><template #append>个</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item
            label="有无风帘"
            label-width="150px"
            prop="windclothflag"
          >
            <el-radio-group
              v-model="editProjectExtInfo.windclothflag"
              size="medium"
            >
              <el-radio-button label="1">有</el-radio-button>
              <el-radio-button label="0">无</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item
            label="有无门帘"
            label-width="150px"
            prop="doorcurtainflag"
          >
            <el-radio-group
              v-model="editProjectExtInfo.doorcurtainflag"
              size="medium"
            >
              <el-radio-button label="1">有</el-radio-button>
              <el-radio-button label="0">无</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row>
        <el-col :span="18">
          <el-form-item
            label="温湿度监测系统探头"
            label-width="150px"
            prop="humiditymonitorflag"
          >
            <el-radio-group
              v-model="editProjectExtInfo.humiditymonitorflag"
              size="medium"
            >
              <el-radio-button label="1">有</el-radio-button>
              <el-radio-button label="0">无</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item
            label="监控系统探头数量"
            label-width="150px"
            prop="humiditymonitorqty"
          >
            <el-input v-model="editProjectExtInfo.humiditymonitorqty"
              ><template #append>个</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item
            label="厂家"
            label-width="150px"
            prop="manufacturer"
          >
            <el-input v-model="editProjectExtInfo.manufacturer">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item
            label="验证对象温度控制范围目标"
            label-width="150px"
            prop=""
          >
            <el-col :span="10">
              <el-form-item
                label="最低温度"
                label-width="100px"
                prop="verifytemperaturemin"
              >
                <el-input v-model="editProjectExtInfo.verifytemperaturemin">
                  <template #append>℃</template>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="10">
              <el-form-item
                label="最高温度"
                label-width="100px"
                prop="verifytemperaturemax"
              >
                <el-input v-model="editProjectExtInfo.verifytemperaturemax">
                  <template #append>℃</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item
            label="冷藏车设置温度"
            label-width="150px"
            prop=""
          >
            <el-col :span="10">
              <el-form-item
                label="最低温度"
                label-width="100px"
                prop="configuretemperaturemin"
              >
                <el-input v-model="editProjectExtInfo.configuretemperaturemin">
                  <template #append>℃</template>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="10">
              <el-form-item
                label="最高温度"
                label-width="100px"
                prop="configuretemperaturemax"
              >
                <el-input v-model="editProjectExtInfo.configuretemperaturemax">
                  <template #append>℃</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item
            label="外部环境"
            label-width="150px"
            prop="outenvtype"
          >
            <el-radio-group
              v-model="editProjectExtInfo.outenvtype"
              size="medium"
            >
              <el-radio-button label="0">阴凉库</el-radio-button>
              <el-radio-button label="1">大气环境</el-radio-button>
              <el-radio-button label="2">缓冲区</el-radio-button>
              <el-radio-button label="3">常温库</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- end ext-->
    </el-form>
    <div slot="footer" class="txt-center">
      <el-button type="primary" @click="handler_saveprojectext()"
        >确定</el-button
      >
    </div>
  </div>
</template>

<script>

export default {
  name: "projectext1",
  props: {
    editProjectExtInfo: {
      type: Object,
      required: true,
    },
    
  },
 
  data() {
    return {
      editProjectExtInfoRules: {
        carnumber: [
          { required: true, message: "车牌号是必需的", trigger: "blur" },
        ],
        length: [{ required: true, message: "长是必需的", trigger: "blur" }],
        width: [{ required: true, message: "宽是必需的", trigger: "blur" }],
        height: [{ required: true, message: "高是必需的", trigger: "blur" }],
        volume: [{ required: true, message: "体积是必需的", trigger: "blur" }],
        deviceqty: [
          { required: true, message: "风机个数是必需的", trigger: "blur" },
        ],
        entryexitqty: [
          { required: true, message: "出入口数是必需的", trigger: "blur" },
        ],
        windclothflag: [
          { required: true, message: "有无风帘是必需的", trigger: "blur" },
        ],
        doorcurtainflag: [
          { required: true, message: "有无门帘是必需的", trigger: "blur" },
        ],
        
        humiditymonitorflag: [
          { required: true, message: "有无温湿度监测系统探头是必需的", trigger: "blur" },
        ],
        // humiditymonitorqty: [
        //   { required: true, message: "监测系统探头数量是必需的", trigger: "blur" },
        // ],
        // manufacturer: [
        //   { required: true, message: "厂家是必需的", trigger: "blur" },
        // ],
        verifytemperaturemin: [
          { required: true, message: "验证对象温度控制范围最低温度是必需的", trigger: "blur" },
        ],
        verifytemperaturemax: [
          { required: true, message: "验证对象温度控制范围最高温度是必需的", trigger: "blur" },
        ],
        configuretemperaturemin: [
          { required: true, message: "冷藏车设置最低温度是必需的", trigger: "blur" },
        ],
        configuretemperaturemax: [
          { required: true, message: "冷藏车设置最高温度是必需的", trigger: "blur" },
        ],
        outenvtype: [
          { required: true, message: "冷库外部环境是必需的", trigger: "blur" },
        ],
        
      },
    };
  },
  watch: {
    editProjectExtInfo: {
      handler(val, oldVal) {
        let length = val.length;
        let width = val.width;
        let height = val.height;
        if (length && width && height) {
          let volume = length * width * height;
          volume = volume.toFixed(2);
          if (volume != this.editProjectExtInfo.volume) {
            this.editProjectExtInfo.volume = volume;
          }
        } else {
          this.editProjectExtInfo.volume = "";
        }
      },
      deep: true, //true 深度监听
    },
  },
  methods: {
    handler_saveprojectext() {
      this.$refs["editProjectExtInfo"].validate((valid) => {
        if (valid) {
          this.$emit('saveprojectext')
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.title{
  text-align: center;
  margin:10px;
}
</style>